import type { Health } from "../../types/database";

interface StatusDotProps {
  health: Health | string | null | undefined;
  active?: boolean;
  size?: number;
  className?: string;
}

const HEALTH_COLOR: Record<string, string> = {
  green: "#7ec699",
  yellow: "#d4a04c",
  red: "#cf6679",
};

export default function StatusDot({
  health,
  active = false,
  size = 9,
  className,
}: StatusDotProps) {
  const color = HEALTH_COLOR[health ?? ""] ?? "var(--plum)";
  return (
    <span
      className={`glossy-radial-bubble ${active ? "pulse-dot" : ""} ${className ?? ""}`}
      style={{
        width: size,
        height: size,
        color,
      }}
      aria-hidden="true"
    />
  );
}
